module.exports = __webpack_public_path__ + "img/idiomas.413879cb.jpg";